<template>
  <div class="widget" @click="updateWidgetInfoView($event)">
    <div class="block mb-0">
      <div class="block-content d-flex">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Widget",
  props: {
    widgets: {
      type: Object,
      default: null
    }
  },
  created() {},
  methods: {
    updateWidgetInfoView(e) {
      this.$emit("widgetClick", { e, widget: this.widgets });
    }
  }
};
</script>

<style lang="scss" scoped>
.widget {
  background-color: $gray-50;
  .block {
    background-color: transparent;
    border-bottom: 1px solid $gray-250;
    box-shadow: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
    .block-content {
      padding: 20px;
      .widget--avatar {
        img {
          border-radius: 50%;
          display: block;
          height: 40px;
          object-fit: cover;
          width: 40px;
        }
        span {
          background-color: $brand-secondary;
          border-radius: 50%;
          color: $brand-primary;
          display: block;
          font-family: "Gotham";
          height: 40px;
          padding: 8px 0;
          text-align: center;
          transition: all 0.3s ease;
          width: 40px;
        }
      }
      .widget--info {
        margin-left: 10px;
        p {
          font-size: $font-size-xs;
          &:first-child {
            color: $gray-900;
            font-family: "Gotham";
            font-weight: 500;
          }
          &:last-child {
            color: $gray-500;
            font-family: "Gotham Book";
          }
        }
      }
    }
  }
  &:hover,
  &.active {
    background-color: $brand-secondary;
    .block-content {
      .widget--avatar {
        span {
          background-color: $brand-primary;
          color: $white;
        }
      }
    }
  }
}
</style>
